export enum Resource {
  Plans = 'plans',
  Organisations = 'organisations',
  Notifications = 'notifications',
  Roles = 'roles',
  Users = 'users',
  AuditLogs = 'auditLogs',
  Revenue = 'revenue',
  Dashboard = 'dashboard',
  Billing = 'billing',
  Security = 'security',
  FeatureFlags = 'feature-flags',
  Analytics = 'analytics',
  Usage = 'usage',
  UpgradeOps = 'upgrade-ops',
}

export enum Action {
  View = 'view',
  Create = 'create',
  Update = 'update',
  Delete = 'delete',
  All = '*',
}

export type Permission = `${Resource}:${Action}` | '*:*'
